// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
// theme
import { hideScroll } from 'src/theme/css';
// components
import Logo from 'src/components/logo';
import { NavSectionMini } from 'src/components/nav-section';
//
import ThemeModeButton from 'src/components/ThemeModeButton';
import Scrollbar from 'src/components/scrollbar';
import LogoutButton from 'src/components/LogoutButton';
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton } from '../_common';

// ----------------------------------------------------------------------

export default function NavMini() {
  const navData = useNavData();

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
        backgroundColor: 'background.paper',
      }}
    >
      <NavToggleButton sx={{ left: NAV.W_MINI - 12 }} />

      <Stack
        sx={{
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Logo sx={{ mx: 'auto', mt: 3, mb: 6 }} />

        <Scrollbar>
          <NavSectionMini data={navData} />
        </Scrollbar>

        <ThemeModeButton sx={{ mb: 2, mt: 4 }} />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            py: 2,
            borderTop: '1px solid',
            borderColor: 'divider',
          }}
        >
          <LogoutButton mini />
        </Box>
      </Stack>
    </Box>
  );
}
